import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {ThemeProvider} from '@mui/material';
import theme from './utils/theme';
import App from './App';
import store from './store';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {SignalRProvider} from './signal/SignalRContext';

//styles
import './index.css';

const element = document.getElementById('root');
const root = createRoot(element as HTMLElement);

root.render(
	<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<SignalRProvider>
					<App />
				</SignalRProvider>
			</ThemeProvider>
		</Provider>
	</GoogleOAuthProvider>
);
